import { Component, OnInit } from '@angular/core';
import { constants } from 'src/app/shared/constants';
import { ErrorService } from 'src/app/shared/services/error.service';
import { Utilities } from 'src/app/shared/utilities';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import { Case, Milestone } from 'src/app/shared/model/itsm';
import { SupportCaseSearchCriteria } from 'src/app/shared/model/searchCriteria';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import FileSaver from 'file-saver';
import * as Highcharts from 'highcharts';


@Component({
  selector: 'app-report-live-itsm',
  templateUrl: './report-live-itsm.component.html',
  styleUrls: ['./report-live-itsm.component.scss']
})
export class ReportLiveItsmComponent implements OnInit {

  // search fields
  type: string;
  dateFrom: string;
  dateTo: string;
  minDate: string;
  maxDate: string;

  ticketError: boolean;
  loading: boolean;

  loadingPDF: boolean;
  caseTypeCV: string[];
  milestoneType: Milestone[];

  tickets: Case[];

  incidents: Case[];
  changes: Case[];
  serviceReqs: Case[];
  problems: Case[];
  alerts: Case[];

  currentSlaType: string;
  slaCustomerMet: number;
  slaCustomerTotal: number;

  sev1TotalFirstResponse: number;
  sev1MetFirstResponse: number;
  sev2TotalFirstResponse: number;
  sev2MetFirstResponse: number;
  sev3TotalFirstResponse: number;
  sev3MetFirstResponse: number;
  sev4TotalFirstResponse: number;
  sev4MetFirstResponse: number;

  // data
  cases: any;
  casesCount: number;
  searchCriteria: SupportCaseSearchCriteria;
  searched: boolean;
  casesLoaded: boolean;

  form: FormGroup;
  public isMSCollapsed = false;

  Highcharts: typeof Highcharts = Highcharts;
  chartDataLoaded: boolean;
  annualChartDataLoaded: boolean;

  updateCategoryPie: boolean;

  catPieChartOptions: any;
  get typesFormArray() {
    return this.form.controls.types as FormArray;
  }

  constructor(private itsmService: ItsmService,
    private errorService: ErrorService,
    private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.dateFrom = Utilities.get1MonthAgo();
    this.dateTo = Utilities.getToday();
    this.minDate = '2021-09-01';
    this.maxDate = '2030-12-12';
    this.loadCache();
    this.form = this.formBuilder.group({
      types: new FormArray([])
    });

  }

  validateDates(): boolean {
    if (!this.dateFrom && !this.dateTo) {
      return true;
    }
    const min = new Date(this.minDate);
    const max = new Date(this.maxDate);
    const to = new Date(this.dateTo);
    const from = new Date(this.dateFrom);

    if (to < min || from < min || to > max || from > max) {
      return false;
    }
    return to > from;
  }

  /**
   * Cache the CV values for the dropdowns
   */
  loadCache() {
    Promise.all([
      this.itsmService.getCachedCV('Case', 'Type'),
      this.itsmService.getCachedMilestones()
    ])
      .then(res => {
        this.caseTypeCV = res[0];
        this.milestoneType = res[1];
        this.milestoneType.forEach(() => this.typesFormArray.push(new FormControl(false)));
      })
      .catch(err => {
        this.errorService.handlerError(err);
      });
  }


  generate() {
  //  this.currentSlaType = type;
    const jsonForm = {
      "fromDate": this.dateFrom,
      "toDate": this.dateTo,
      "types": [this.currentSlaType === 'firstresponse' ? constants.mileStoneReferences.firstresponse : this.currentSlaType === 'customersla' ? constants.mileStoneReferences.resolution : '']
    }

    const to = new Date(this.dateTo);
    const from = new Date(this.dateFrom);

    var diff = Math.abs(from.getTime() - to.getTime());
    var diffDays = Math.ceil(diff / (1000 * 3600 * 24));

    if (diffDays > 93) {
      this.errorService.handlerError("Report timeframes are restricted to a maximum of 3 months");
    }

    this.loading = true;

    this.itsmService.getLiveReport(jsonForm)
      .then(data => {
        this.cases = data["list"];

        this.incidents = this.cases.filter(a => a["Case"]["Type"] === "Incident");
        this.changes = this.cases.filter(a => a["Case"]["Type"] === "Change Request");
        this.serviceReqs = this.cases.filter(a => a["Case"]["Type"] === "Service Request");
        this.problems = this.cases.filter(a => a["Case"]["Type"] === "Problem");
        this.alerts = this.cases.filter(a => a["Case"]["Type"] === "Alert");

        if (this.currentSlaType === 'firstresponse') {

          this.slaCustomerTotal = this.cases.filter(a => a["MilestoneType"]["Name"] === "First Response").length;
          this.slaCustomerMet = this.cases.filter(a => a["MilestoneType"]["Name"] === "First Response" && a["IsViolated"] === false).length;


          this.sev1TotalFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "1 - Business Critical" && a["MilestoneType"]["Name"] === "First Response").length;
          this.sev1MetFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "1 - Business Critical" && a["MilestoneType"]["Name"] === "First Response" &&
            a["IsViolated"] === false).length;

          this.sev2TotalFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "2 - High" && a["MilestoneType"]["Name"] === "First Response").length;
          this.sev2MetFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "2 - High" && a["MilestoneType"]["Name"] === "First Response" &&
            a["IsViolated"] === false).length;

          this.sev3TotalFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "3 - Medium" && a["MilestoneType"]["Name"] === "First Response").length;
          this.sev3MetFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "3 - Medium" && a["MilestoneType"]["Name"] === "First Response" &&
            a["IsViolated"] === false).length;

          this.sev4TotalFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "4 - Low" && a["MilestoneType"]["Name"] === "First Response").length;
          this.sev4MetFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "4 - Low" && a["MilestoneType"]["Name"] === "First Response" &&
            a["IsViolated"] === false).length;

        }else if(this.currentSlaType === 'customersla') {
          
          this.slaCustomerTotal = this.cases.filter(a => a["MilestoneType"]["Name"] === "Customer SLA").length;
          this.slaCustomerMet = this.cases.filter(a => a["MilestoneType"]["Name"] === "Customer SLA" && a["IsViolated"] === false).length;


          this.sev1TotalFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "1 - Business Critical" && a["MilestoneType"]["Name"] === "Customer SLA").length;
          this.sev1MetFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "1 - Business Critical" && a["MilestoneType"]["Name"] === "Customer SLA" &&
            a["IsViolated"] === false).length;

          this.sev2TotalFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "2 - High" && a["MilestoneType"]["Name"] === "Customer SLA").length;
          this.sev2MetFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "2 - High" && a["MilestoneType"]["Name"] === "Customer SLA" &&
            a["IsViolated"] === false).length;

          this.sev3TotalFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "3 - Medium" && a["MilestoneType"]["Name"] === "Customer SLA").length;
          this.sev3MetFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "3 - Medium" && a["MilestoneType"]["Name"] === "Customer SLA" &&
            a["IsViolated"] === false).length;

          this.sev4TotalFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "4 - Low" && a["MilestoneType"]["Name"] === "Customer SLA").length;
          this.sev4MetFirstResponse = this.cases.filter(a => a["Case"]["Priority"] === "4 - Low" && a["MilestoneType"]["Name"] === "Customer SLA" &&
            a["IsViolated"] === false).length;
        }

        this.drawGraph();
        this.loading = false;
      })
      .catch(err => {
        this.errorService.handlerError(err);
        this.loading = false;
      });
  }

  generatePDF() {
    this.loadingPDF = true;

    const jsonForm = {
      "fromDate": this.dateFrom,
      "toDate": this.dateTo,
      "types": [this.currentSlaType === 'firstresponse' ? constants.mileStoneReferences.firstresponse : this.currentSlaType === 'customersla' ? constants.mileStoneReferences.resolution : '']
    }

    this.itsmService.getLivePDFReport(jsonForm)
      .then(val => {
        var file = new Blob([val], { type: val.type });
        FileSaver.saveAs(file, "OrangeCyberdefense-ServiceManagementReport-" + this.dateFrom + ".pdf");
        this.loadingPDF = false;
      })
      .catch(err => {
        this.loadingPDF = false;
        this.errorService.handlerError(err);
      });
  }

  drawGraph() {
    this.catPieChartOptions = {
      colors: constants.graphContrastingColors,
      chart: {
        type: 'column'
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      title: {
        text: 'Percentage of tickets resolved within SLA'
      },
      subtitle: {
        text: 'By Priority'
      },
      xAxis: {
        categories: ['1-Critical', '2-High', '3-Medium', '4-Low'],
        crosshair: true
      },
      yAxis: {
        min: 0,
        max: 100,
        title: {
          text: 'Percentage'
        }
      },
      tooltip: {
        headerFormat: '<span style = "font-size:10px"><b>{point.y:.0f}</b></span>',
        pointFormat: '', footerFormat: '', shared: true, useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [
        {
          name: 'SLA Percentage Resolved',
          data: [
            { y: ((this.sev1MetFirstResponse / this.sev1TotalFirstResponse) * 100), color: '#A885D8' },
            { y: ((this.sev2MetFirstResponse / this.sev2TotalFirstResponse) * 100), color: '#FFD200' },
            { y: ((this.sev3MetFirstResponse / this.sev3TotalFirstResponse) * 100), color: '#4BB4E6' },
            { y: ((this.sev4MetFirstResponse / this.sev4TotalFirstResponse) * 100), color: '#50BE87' }
          ]
        }
      ]
    };
  }

}
